<template>
    <div>
        <div class="banner">
            <div class="headerReplacementNewInfo"></div>
            <div class="banner-text">
                <b>{{ $t('electronicAdvertising.title') }}</b>
                <div class="breadcrumb">
                    <span>
                        <router-link to="/" class="pe-auto">{{ $t('electronicAdvertising.home') }}</router-link>
                    </span>
                    <span class="separator"></span>
                    <span>{{ $t('electronicAdvertising.newsRoom') }}</span>
                    <span class="separator"></span>
                    <span><b>{{ $t('electronicAdvertising.title') }}</b></span>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="TabMenu">
                <NewInfoTabMenu />
            </div>

            <div class="row g-3 justify-content-center align-items-center mt-3 mb-5">
                <div class="col-md-auto">
                    <label class="col-form-label">{{ $t('electronicAdvertising.search') }}</label>
                </div>
                <div class="col-md-6 position-relative">
                    <input type="text" class="form-control pe-5" :placeholder="$t('electronicAdvertising.search')" />
                    <i class="fas fa-search position-absolute top-50 end-0 translate-middle-y me-3"></i>
                </div>
                <div class="col-md-auto">
                    <label class="col-form-label">{{ $t('electronicAdvertising.selectYear') }}</label>
                </div>
                <div class="col-md-2">
                    <select v-model="selectedYear" id="yearSelect" class="form-select" aria-label="Year selection">
                        <option value="2024">2024</option>
                    </select>
                </div>
            </div>

            <div class="container mb-5">
                <div v-for="(item, index) in filteredPaginatedList" :key="index" class="row border-bottom g-2 mb-5">
                    <div class="col-6 text-start">
                        <div class="fw-bold mb-3">{{ item.title_ad_electronic }}</div>
                    </div>
                    <div class="col-6 text-end">
                        <div class="mt-5 text-secondary">
                            <a :href="item.url_ad_electronic" target="_blank">
                                <small>{{ $t('electronicAdvertising.readMore') }}</small>
                            </a>
                        </div>
                    </div>
                </div>

                <div v-if="isLoading" class="d-flex justify-content-center align-items-center" style="height: 100px;">
                    <div class="spinner-grow custom-spinner" role="status"></div>
                </div>

                <!-- Pagination Controls -->
                <nav aria-label="Page navigation example">
                    <ul class="pagination justify-content-center">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                            <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">
                                {{ $t('electronicAdvertising.prev') }}
                            </a>
                        </li>
                        <li class="page-item" v-for="page in totalPages" :key="page"
                            :class="{ active: currentPage === page }">
                            <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                            <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">
                                {{ $t('electronicAdvertising.next') }}
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>
  
<script>
import NewInfoTabMenu from '@/components/NewInfoTabMenu.vue';
import store from "@/store";
import { GET_AD_ELECTRONIC_DATA } from "../../store/actions.type";
import dayjs from 'dayjs';

export default {
    name: 'ElectronicAdvertising',
    components: {
        NewInfoTabMenu,
    },
    data() {
        return {
            list: [],
            selectedYear: '2024', // Set the default year to 2024
            searchQuery: '', // Add searchQuery to bind with the search input field
            perPage: 5,
            currentPage: 1,
            isLoading: false,

        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.filteredList.length / this.perPage);
        },

        filteredList() {
            return this.list.filter(item => {
                const itemYear = dayjs(item.publish_date_ad_electronic).year();
                // Filter by year
                const matchesYear = itemYear === parseInt(this.selectedYear);

                // Ensure title_ad_electronic is a valid string before calling toLowerCase()
                const matchesSearch = (item.title_ad_electronic || '').toLowerCase().includes(this.searchQuery.toLowerCase());

                return matchesYear && matchesSearch; // Only show items that match both year and search query
            });
        },

        filteredPaginatedList() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.filteredList.slice(start, end);
        }
    },
    watch: {
        '$i18n.locale'(newLang) {
            this.init();
        }
    },

    async created() {
        this.isLoading = true;
        await this.init();
        this.isLoading = false;
    },
    methods: {
        async init() {
            const lang = this.$i18n.locale || 'th';
            this.list = await store.dispatch(GET_AD_ELECTRONIC_DATA, lang);
        },
        formatDate(dateString) {
            return dayjs(dateString).format('DD MMMM YYYY');
        },

        changePage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
        }
    },

};
</script>
<style scoped>
th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.table th {
    font-size: 0.85rem;
    font-weight: normal;
    padding: 8px;
}


.pagination .page-item.active .page-link {
    background-color: #E87D2E;
    /* Active page color */
    color: white;
    font-weight: bold;
    border: none;
}

.pagination .page-item.disabled .page-link {
    color: #d6d6d6;
    /* Disabled page color */
    cursor: not-allowed;
}

.page-item .page-link {
    color: black;
}

.page-link {
    cursor: pointer;
}
</style>
  